(function () {

    'use strict';

    angular.module('iplusjs.validator.exists', [
        'lodash',
        'iplusjs.fieldset'
    ])
    .directive('iplusjsExistsValidator', existsValidator);

    existsValidator.$inject = [
        '$q',
        '$log',
        'lodash'
    ];
    function existsValidator($q, $log, _) {
        return {
            require: ['ngModel', '^?iplusjsFieldset'],
            link: linkFnc
        };

        function linkFnc($scope, $elem, $attrs, ctrls) {
            var $ngModel = ctrls[0],
                fieldsetCtrl = ctrls[1],
                existsFn = $scope.$eval($attrs.iplusjsExistsValidator);

            if ($attrs.disabled || $scope.$eval($attrs.ngDisabled) || (fieldsetCtrl && fieldsetCtrl.disabled) || !angular.isFunction(existsFn)) {
                return;
            }
            $ngModel.$asyncValidators.exists = function (value) {
                return $q(function (resolve, reject) {
                    $log.debug('existsValidator $asyncValidators.exists');

                    return existsFn(value).then(function (data) {
                        if (!data || !data.length) {
                            return reject();
                        }

                        resolve();
                    }).catch(function (error) {
                        reject();
                    });
                });
            };
        }
    }
})();
